var React = require('react');

function SliderArrowRight (props) {
    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0},"\r\n\t.st0{fill:none;stroke:#FFFFFF;stroke-width:10;}\r\n"),React.createElement("path",{"id":"arrow_copy_3","className":"st0","d":"M12,5l13.3,12.8L12,30.7","key":1})]);
}

SliderArrowRight.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 30.3 35.7","style":{"enableBackground":"new 0 0 30.3 35.7"},"xmlSpace":"preserve"};

module.exports = SliderArrowRight;

SliderArrowRight.default = SliderArrowRight;
